"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
var CustomError_1 = require("./CustomError");
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _this = _super.call(this, message) || this;
        _this.errorCode = 0 /* ErrorNames.E000 */;
        _this.errorType = 'VALIDATION_ERROR';
        _this.message = 'VALID';
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    ValidationError.prototype.serializeErrors = function () {
        return [
            {
                message: this.message || '',
                errorCode: this.errorCode,
                errorType: this.errorType,
            },
        ];
    };
    return ValidationError;
}(CustomError_1.CustomError));
exports.ValidationError = ValidationError;
